import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: var(--wg-dark-blue);
`

const SkinnyPlus = ({ title = 'Plus', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M15,7H9V1c0-0.6-0.4-1-1-1S7,0.4,7,1v6H1C0.4,7,0,7.4,0,8s0.4,1,1,1h6v6c0,0.6,0.4,1,1,1s1-0.4,1-1V9h6 c0.6,0,1-0.4,1-1S15.6,7,15,7z"
    />
  </StyledIcon>
)

SkinnyPlus.displayName = 'SkinnyPlus'
SkinnyPlus.needsWork = true
export default SkinnyPlus
